import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeDetailDialog,
  fetchEventDetail,
  selectDetailDialogEventId,
  selectDetailState,
  selectEventById,
} from "../../store/slices/eventsSlice";
import EventStatusChip from "./EventStatusChip";
import { formatDateJakarta, formatDateTimeJakarta } from "../../utils/date";

const Field = ({ label, value }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Box sx={{ mt: 0.5 }}>
      {typeof value === "string" || typeof value === "number" ? (
        <Typography variant="body1" fontWeight={600}>
          {value}
        </Typography>
      ) : (
        value
      )}
    </Box>
  </Box>
);

const EventDetailDialog = () => {
  const dispatch = useDispatch();
  const eventId = useSelector(selectDetailDialogEventId);
  const event = useSelector((state) => selectEventById(state, eventId));
  const detailState = useSelector(selectDetailState);

  const handleClose = () => dispatch(closeDetailDialog());

  useEffect(() => {
    if (eventId && !event) {
      dispatch(fetchEventDetail(eventId));
    }
  }, [dispatch, eventId, event]);

  const dialogTitle = event ? event.name : "Event Details";

  return (
    <Dialog open={Boolean(eventId)} onClose={handleClose} maxWidth="sm" fullWidth>
      {eventId && (
        <>
          <DialogTitle
            sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
          >
            <Box>
              <Typography variant="h6">{dialogTitle}</Typography>
              <Typography variant="body2" color="text.secondary">
                Event ID #{event?.id || eventId}
              </Typography>
            </Box>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {!event && (
              <Typography variant="body2" color="text.secondary">
                {detailState.loading
                  ? "Loading event details..."
                  : detailState.error || "Event details are unavailable."}
              </Typography>
            )}
            {event && (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Field label="Start" value={formatDateJakarta(event.start_datetime)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field label="End" value={formatDateJakarta(event.end_datetime)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field label="Status" value={<EventStatusChip status={event.status} />} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      label="Event Rule"
                      value={event.event_rule === "GBK_LOCKED" ? "GBK Locked" : "No Restriction"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field
                      label="Limit Per Ticket"
                      value={event.limit_per_ticket === 0 ? "Unlimited" : event.limit_per_ticket}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field label="Created" value={formatDateTimeJakarta(event.created_datetime)} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Field label="Updated" value={formatDateTimeJakarta(event.updated_datetime)} />
                  </Grid>
                </Grid>
              </>
            )}
          </DialogContent>
        </>
      )}
    </Dialog>
  );
};

export default EventDetailDialog;
